import { render, staticRenderFns } from "./SubmissionReviewFormRatingsMultiCategoryPoints.vue?vue&type=template&id=c38b11f0&scoped=true&"
import script from "./SubmissionReviewFormRatingsMultiCategoryPoints.vue?vue&type=script&lang=js&"
export * from "./SubmissionReviewFormRatingsMultiCategoryPoints.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionReviewFormRatingsMultiCategoryPoints.vue?vue&type=style&index=0&id=c38b11f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38b11f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
